import { FormControl, FormGroup, Validators } from '@angular/forms';

export interface Client {
  [key: string]: any;
}

export interface ClientDetails {
  data: Client;
  status: number;
  message: string;
}

export interface ClientRecordForDialogue {
  selectedRow: Client;
}

const FIELD_CONFIGS = [
  { key: 'select', dataType: 'boolean', maxLength: 5 },
  { key: 'fdClientId', dataType: 'number', maxLength: 50 },
  { key: 'companyName', dataType: 'string', maxLength: 255 },
  { key: 'contactFirstName', dataType: 'string', maxLength: 100 },
  { key: 'contactLastName', dataType: 'string', maxLength: 100 },
  { key: 'fdParentClientId', dataType: 'number', maxLength: 50 },
  { key: 'verifiClientId', dataType: 'string', maxLength: 50 },
  { key: 'verifiPartnerId', dataType: 'string', maxLength: 50 },
  { key: 'verifiPartnerIdClientId', dataType: 'string', maxLength: 50 },
  { key: 'autoResolve', dataType: 'number', maxLength: 50 },
  { key: 'ethocaMerchantId', dataType: 'string', maxLength: 50 },
  { key: 'ethocaMerchantName', dataType: 'string', maxLength: 255 },
  { key: 'defaultDataOnly', dataType: 'number', maxLength: 50 },
  { key: 'fdRequestId', dataType: 'string', maxLength: 50 },
  { key: 'active', dataType: 'number', maxLength: 1 },
  { key: 'demoAccount', dataType: 'number', maxLength: 1 },
  { key: 'billingCadence', dataType: 'string', maxLength: 50 },
  { key: 'invoicedClientId', dataType: 'number', maxLength: 50 },
  { key: 'netPaymentTermsDays', dataType: 'number', maxLength: 50 },
  { key: 'paymentMethod', dataType: 'string', maxLength: 50 },
  { key: 'contractPhone', dataType: 'string', maxLength: 20 },
  { key: 'contactEmail', dataType: 'string', maxLength: 100 },
  { key: 'partnerType', dataType: 'string', maxLength: 50 },
  { key: 'level1Commission', dataType: 'number', maxLength: 50 },
  { key: 'level2Commission', dataType: 'number', maxLength: 50 },
  { key: 'level3Commission', dataType: 'number', maxLength: 50 },
  { key: 'numberOfChildLevels', dataType: 'number', maxLength: 50 },
  { key: 'overheadCost', dataType: 'number', maxLength: 50 },
  { key: 'externalClientIdentifier', dataType: 'string', maxLength: 50 },
  { key: 'nickName', dataType: 'string', maxLength: 50 },
  { key: 'legalName', dataType: 'string', maxLength: 255 },
  { key: 'address1', dataType: 'string', maxLength: 255 },
  { key: 'address2', dataType: 'string', maxLength: 255 },
  { key: 'city', dataType: 'string', maxLength: 100 },
  { key: 'state', dataType: 'string', maxLength: 50 },
  { key: 'postalCode', dataType: 'string', maxLength: 20 },
  { key: 'country', dataType: 'string', maxLength: 50 },
  { key: 'contactPhone', dataType: 'string', maxLength: 20 },
  { key: 'mdMasterItemId', dataType: 'string', maxLength: 50 },
  { key: 'createdDate', dataType: 'date', maxLength: 50 },
  { key: 'lastUpdated', dataType: 'date', maxLength: 50 },
  { key: 'mdItemId', dataType: 'string', maxLength: 50 },
  { key: 'status', dataType: 'string', maxLength: 50 },

];

const GROUPED_FIELDS = {
  Category1: ['fdClientId', 'companyName', 'contactFirstName', 'contactLastName'],
  Category2: ['fdParentClientId', 'verifiClientId', 'verifiPartnerId', 'verifiPartnerIdClientId', 'autoResolve'],
  Category3: ['ethocaMerchantId', 'ethocaMerchantName', 'defaultDataOnly', 'fdRequestId', 'active'],
  Category4: ['demoAccount', 'billingCadence', 'invoicedClientId', 'netPaymentTermsDays', 'paymentMethod', 'contractPhone', 'contactEmail'],
  Category5: ['partnerType', 'level1Commission', 'level2Commission', 'level3Commission', 'numberOfChildLevels', 'overheadCost'],
  Category6: ['externalClientIdentifier', 'nickName', 'legalName', 'address1', 'address2', 'city', 'state', 'postalCode', 'country'],
  Category7: ['contactPhone', 'mdMasterItemId', 'createdDate', 'lastUpdated', 'mdItemId'],
};

export const CLIENT_FIELDS_EDIT = FIELD_CONFIGS.reduce((editModel, field) => {
  editModel[field.key] = { dataType: field.dataType, maxLength: field.maxLength };
  return editModel;
}, {});

export const CLIENT_COLUMN_FORMATTED = FIELD_CONFIGS.reduce((columnFormatted, field) => {
  columnFormatted[field.key] = field.key.replace(/(^\w|[A-Z]|\d)/g, ' $1').trim().replace(/^\w/, (c) => c.toUpperCase());
  return columnFormatted;
}, {});

export const CLIENT_COLUMNS_SEARCH_INPUT = [
  ...Object.keys(CLIENT_COLUMN_FORMATTED).map((column) => `searchInput_${column}`),
];

export const CLIENT_COLUMNS = Object.keys(CLIENT_COLUMN_FORMATTED);


export const Client_Categorized = Object.keys(GROUPED_FIELDS).reduce((fieldCategory, category) => {
  fieldCategory[category] = GROUPED_FIELDS[category].reduce((catAcc, field) => {
    catAcc[field] = '';
    return catAcc;
  }, {});
  return fieldCategory;
}, {});

type ToFormControls<T> = {
  [K in keyof T]: FormControl<T[K]>;
};

export type ClientFormControl = ToFormControls<Client>;
export const clientForm = new FormGroup<ClientFormControl>(
  FIELD_CONFIGS.reduce((controls, field) => {
    controls[field.key] = new FormControl('', Validators.maxLength(field.maxLength));
    return controls;
  }, {} as any)
);

export interface PartnerClient {
  value: number;
  label: string;
}

export interface PartnerClientsResponse {
  data: PartnerClient[];
}
